import classNames from "classnames"
import type { FC, ReactNode } from "react"

import Link from "../Link"

const HeaderLink: FC<{
  title: string
  popover?: ReactNode
  url?: string
}> = ({ title, url }) => {
  const className = classNames(
    "hover:bg-[#162557] font-serif rounded-full py-1 px-3 text-base"
  )

  return (
    <div className="flex h-16 items-center justify-center lg:h-14">
      <Link to={url} className={classNames("cursor-pointer", className)}>
        {title}
      </Link>
    </div>
  )
}

export default HeaderLink
